import React from 'react';
import { TimeCastSegmentGroup } from 'store/home.store';
import { DeprecatedDesktopCaptureData, DesktopCaptureData } from '../../api/types/types';
import {
    IconDefinition,
    faFileWord,
    faFilePowerpoint,
    faFileExcel,
    faEnvelope,
    faDatabase,
    faFileInvoice,
    faUpload,
    faFilePdf,
    faFileAlt,
    faFile,
    faCalendarDay, 
    faPaperPlane, 
    faPhoneAlt,
    faUserGroup,
    faUsers,
    faVideo,
    faWallet
} from '@fortawesome/free-solid-svg-icons';
import { faFirefox, faChrome, faSkype, faEdge, faEdgeLegacy, faInternetExplorer }
    from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { theme } from 'common/theme';

interface Props {
    group: TimeCastSegmentGroup;
    color?: string
}

const programIcons: Record<string, IconDefinition> = {
    'MS_WORD' : faFileWord,
    'MS_POWERPOINT': faFilePowerpoint,
    'MS_PUBLISH': faFileInvoice,
    'MS_EXCEL': faFileExcel,
    'MS_OUTLOOK': faEnvelope,
    'MS_ACCESS': faDatabase,
    'OFFICE_UPLOADCTR': faUpload,
    'MOZILLA_FIREFOX': faFirefox,
    'GOOGLE_CHROME': faChrome,
    'MS_LYNC': faSkype,
    'MS_LYNC_RECORDER': faSkype,
    'MS_EDGE': faEdgeLegacy,
    'ADOBE_ACROBAT': faFilePdf,
    'MS_IEXPLORER': faInternetExplorer,
    'WS_DECK_COMPARE': faFileAlt,
    'WS_COMPARE': faFileAlt,
    'WS_CARBON': faFileAlt,
    'WS_PDF_COMBINE': faFileAlt,
    'DOCSCORP_CMPRDOCS': faFile,
    'MS_TEAMS': faUsers,
    'ZOOM': faVideo,
    'NET_DOCUMENTS': faWallet,
    
    // dummy programs
    'PHONE_CALL' : faPhoneAlt,
    'CALENDAR_EVENT': faCalendarDay,
    'TEAMS_CALL': faUserGroup,
    'SENT_MAIL': faPaperPlane,
    'MS_EDGE_NEW': faEdge
}

const Icon = styled(FontAwesomeIcon)`
  margin-right: 10px;
`

export const DesktopCaptureIcon = (props: {color: string, program?: string}) => {
    // @ts-ignore
    const icon: IconProp = programIcons[props.program || ''];
    
    return (icon ?
            <Icon icon={icon} style={{color: props.color}} />
        :
            (
                <div
                    style={{
                        display: 'inline-block',
                        width: '13px',
                        height: '13px',
                        backgroundColor: `${props.color || theme.black.light}`,
                        marginRight: '10px',
                        border: `1px solid ${theme.black.light}`
                    }}
                />
            )
    );
}

export const DesktopCaptureDescription = (props: Props) => {
    const group = props.group;

    return (
        <>
            {props.color && <DesktopCaptureIcon color={props.color} program={props.group.application} />}
            {group.segments.length > 0
                ? ((group.segments[group.segments.length - 1].data as DesktopCaptureData).title 
                || (group.segments[group.segments.length - 1].data as DeprecatedDesktopCaptureData).windowTitle)
                : group.title}
        </>
    );
};